import React from "react";
import styles from "./MonthlyEarnings.module.scss";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";

const earningsData = [
    { month: "Oct", earnings: 100, color: "#ca2114" },
    { month: "Nov", earnings: 300, color: "#e36800" },
    { month: "Dec", earnings: 600, color: "#f0ac00" },
    { month: "Jan", earnings: 900, color: "#cfb800" },
    { month: "Feb", earnings: 1200, color: "#88c100" },
    { month: "Mar", earnings: 1500, color: "#01a300" },
];

const MonthlyEarnings = () => {
    return (
        <div className={styles.chartCard}>
            <h3 className={styles.chartTitle}>Monthly Earning</h3>
            <ResponsiveContainer width="100%" height={550}>
                <BarChart data={earningsData} barCategoryGap={30}>
                    <XAxis
                        dataKey="month"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: "#1A2425", fontSize: 18, dy: 8 }}
                    />
                    <YAxis hide />
                    {/* <Tooltip cursor={{ fill: "transparent" }} /> */}
                    <Bar
                        dataKey="earnings"
                        shape={(props) => <Custom3DBar {...props} />}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

// ✅ Custom 3D Bar Component
const Custom3DBar = (props) => {
    const { x, y, width, height, value, payload } = props;
    const fill = payload.color;
    const depth = 15;

    return (
        <g>
            {/* 🔥 Define SVG Box-Shadow Filter */}
            <defs>
                <filter id="shadow" x="-20%" y="-20%" width="300%" height="150%">
                    <feDropShadow
                        dx="5"
                        dy="5"
                        stdDeviation="4"
                        floodColor="rgba(0, 0, 0, 0.3)"
                    />
                </filter>
            </defs>

            {/* 🔹 Top Face (Lighter Color) */}
            <polygon
                points={`
                    ${x},${y} 
                    ${x + width},${y} 
                    ${x + width - depth},${y - depth} 
                    ${x - depth},${y - depth}
                `}
                fill={fill}
                opacity="0.8"
                filter="url(#shadow)"
            />

            {/* 🔹 Right Side Face (Darker for Depth) */}
            <polygon
                points={`
                    ${x + width},${y} 
                    ${x + width - depth},${y - depth} 
                    ${x + width - depth},${y + height - depth} 
                    ${x + width},${y + height}
                `}
                fill={fill}
                opacity="0"
                filter="url(#shadow)"
            />

            {/* 🔹 Left Side Face (Lighter Side for Depth) */}
            <polygon
                points={`
                    ${x},${y} 
                    ${x - depth},${y - depth} 
                    ${x - depth},${y + height - depth} 
                    ${x},${y + height}
                `}
                fill={fill}
                opacity="0.8"
            />

            {/* 🔹 Front Face (Main Bar) */}
            <polygon
                points={`
                    ${x},${y} 
                    ${x + width},${y} 
                    ${x + width},${y + height} 
                    ${x},${y + height}
                `}
                fill={fill}
                filter="url(#shadow)"
            />

            {/* 💬 Label Above Bar */}
            <text
                x={x + width / 2 - 10}
                y={y - 22}
                textAnchor="middle"
                fontSize={20}
                fontWeight={600}
                fill="#1A2425"
            >
                ${value}
            </text>
        </g>
    );
};

export default MonthlyEarnings;